module.exports = __webpack_public_path__ + "static/media/MNFLX-UST.da611933.svg";